export default "__VITE_ASSET__Cj01UXtn__"